export default "__VITE_ASSET__DRokcxuN__"